import React from 'react';
import Card from '@mui/material/Card';
import WarranteeMainCard from './WarrenteeMainCard';
import UnauthorisedAccess from '../CommonComponents/UnauthorisedAccess';


function Warrantee() {

  const [useType, setUseType] = React.useState(localStorage.getItem('type'));

  return useType === 'technician' ? <UnauthorisedAccess /> :  (
    <Card
      xs={{
        '.css-bhp9pd-MuiPaper-root-MuiCard-root': { boxShadow: 'none' },
        maxHeight: '100%',
        minHeight: '70%',
        width: '100%',
        background: 'none',
        border: 'none',
        boxShadow: 'none',
      }}
    >
      <WarranteeMainCard />
    </Card>
  );
}

export default Warrantee;
